import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import dayjs from 'dayjs'
import { NbPopoverDirective } from "@nebular/theme";
import { QueryList, ViewChildren } from "@angular/core";

// For all components that are used to crteat an entry of a certain data type
import { Component } from '@angular/core';
import { IDataTypeComponentWithForm } from "../interfaces/sharedComponents";
import { allInputDataTypes, entryProp, indexDataField } from "../interfaces/apiCalls";
import { ApiService } from "../services/api/api.service";
import { StateService } from "../@core/utils";
import { DateValidator, BoolValidator, PasswordValidator, MatriculeValidator } from "../utils/validators.validator";
import { environment } from "../../environments/environment";
import { DevicesService } from "../services/devices/devices.service";
import { docType } from "../shared-types/datatypes";
import { LocationAddress } from "../pages/forms/address-search/address-FE-schema";
import { TranslateService } from "@ngx-translate/core";


export class BaseCreatingEditingInitParams{
  fb: FormBuilder
  api: ApiService  
  devices: DevicesService
  dataType: docType
  translate: TranslateService;


  constructor(init: IBaseCreatingEditingInitParams){
    this.fb = init.fb;
    this.api = init.api;
    this.devices = init.devices;
    this.dataType = init.dataType;
  }
}

export interface IBaseCreatingEditingInitParams{
  fb: FormBuilder,
  api: ApiService
  devices: DevicesService
  dataType: docType
}

@Component({
  template: ''
})
export abstract class BaseCreatingEditing implements IDataTypeComponentWithForm {
    @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;
    
    api: ApiService;
    fb: FormBuilder;
    public entryForm: FormGroup
    environment = environment; // reference to environment variables, for use in template
    devices: DevicesService;
    dataType: docType; // the data type for which this component is used - legacy aming was dataType instead of docType, sorry!
    docTypeSettings: any; // the settings for this specific data/document type, e.g. users - fetched from either local storage(electron) or the API
    public translate: TranslateService; // translate service for use in the component
    protected dataSchema: entryProp[];


    constructor(init: BaseCreatingEditingInitParams){
        const {fb, api, devices, translate} = init;
        this.api = api;
        this.fb = fb;
        this.devices = devices;
        this.entryForm = this.fb.group({});
        this.translate = translate;

    }
      
    setInputFieldWarningPopovers() {
        /* don't show popups for form controls that are tagged 'visible', the corresponding form inputs are tagged with the originnal name */
        Object.keys(this.entryForm.controls)
          .filter((input) => input.endsWith("-visible") == false)
          .forEach((input) => {
            this.entryForm.controls[input].valueChanges.subscribe(
              (data) => {
                this.entryForm.controls[input].invalid
                  ? this.setPopoverVisible(input, true, 3000)
                  : this.setPopoverVisible(input, false);
              }
            );
          });
      }
      
      getDocTypeSettings(docType: any) {

      }

      setCorrectDate(event, controlName, source) {
        let day = dayjs(event)
        let correctFormField: AbstractControl = this.entryForm.controls[controlName];
        // set what to display in form field
        // set what value to put in form control, but don't emit event to view
        correctFormField.setValue(day.format('YYYY-MM-DD'))
      }

      checkValidity(inputName: string) {
        // assuming there are only VALID and INVALID statuses right now.
        let isValid : boolean =  (this.entryForm.controls[inputName] as AbstractControl).status == "INVALID" ? false : true
        try{
          this.setPopoverVisible(inputName, !isValid, 3000)
        } catch(e) {
          console.devlog("No popup to show for ", inputName, e)
        }
      }

      setDateToFormcontrol(event, controlName, type : allInputDataTypes) {
        let value = event.target.value
      // Regex pattern to math input a la 11-21-24
        const pattern = /(\d+)[^\d]+(\d+)[^\d]+(\d+)/;
    
        // Find matches
        const matches = value.match(pattern);
    
        if (matches) {
          let day = dayjs()
          // Extract numbers
          const firstNumber = matches[1];
          const secondNumber = matches[2];
          const thirdNumber = matches[3];
    
          let setDay = day.set('date', firstNumber).set('month', secondNumber).set('year', thirdNumber)
    
            // console.log(`Day: ${setDay.get('date')} Month: ${setDay.get('month')} Year: ${setDay.get('year')}`);
            // console.log("Final day", setDay.toDate())
            // console.log("day valid?", setDay.isValid())
            
            var yearShorterThanBefore = false
    
            const correctFormField: AbstractControl = this.entryForm.controls[controlName];
            if(!correctFormField['_prevThirdValue']) {
              correctFormField['_prevThirdValue'] = thirdNumber
            } else {
              yearShorterThanBefore = thirdNumber.toString().length < correctFormField['_prevThirdValue'].toString().length
              correctFormField['_prevThirdValue'] = thirdNumber
            }
            if (setDay.isValid()) {
    
              // console.log("setting value on form !")
              // let correctFormFieldVisible: AbstractControl = this.entryForm.controls[controlName + '-visible'];
              // set what to display in form field
              // set what value to put in form control, but don't emit event to view
    
         
              // first we set thirdNumber as the final year and then correct it if we autocomplete it further down below.
              var finalYear = thirdNumber
    
              // do NOT perform auto complete if somebody starts typing 19 or 20, as we can't know if they mean 19.. or 2019, etc.
            if (![19, 20].includes(parseInt(thirdNumber))) {
    
    
                    // if type is dateBefore, we autocomplete everything past this year to 1900s.
            if (["dateBefore", "dateAny"].includes(type)) {
                    // when the type is birthday, we want to auto-complete the year to 1900s, i.e. 25 = 1925, etc, when the entered year is above the two-digit representation of the current year.
                    if(thirdNumber.length == 2 && !yearShorterThanBefore && parseInt(thirdNumber) > parseInt(dayjs().year().toString().slice(-2))){
                      event.target.value = `${firstNumber}-${secondNumber}-19${thirdNumber}`
                      finalYear = parseInt(`19${thirdNumber}`)
                      event.target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
                    } else if(thirdNumber.length == 2 && !yearShorterThanBefore && parseInt(thirdNumber) <= parseInt(dayjs().year().toString().slice(-2))) {
                      event.target.value = `${firstNumber}-${secondNumber}-20${thirdNumber}`
                      finalYear = parseInt(`20${thirdNumber}`)
                      event.target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
                    }
                  } else if (type == "dateAfter") {
                    // when the type is dateAfter, we want to always auto-complete the year to 2000s, i.e. 25 = 2025, etc, 
                    if(thirdNumber.length == 2 && !yearShorterThanBefore ){
                      event.target.value = `${firstNumber}-${secondNumber}-20${thirdNumber}`
                      finalYear = parseInt(`20${thirdNumber}`)
                      event.target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
                    } else if(thirdNumber.length == 2 && !yearShorterThanBefore && parseInt(thirdNumber) >= parseInt(dayjs().year().toString().slice(-2))) {
                      event.target.value = `${firstNumber}-${secondNumber}-19${thirdNumber}`
                      finalYear = parseInt(`19${thirdNumber}`)
                      event.target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
                    }
                  } 
    
                let finalDate = day.set('date', firstNumber).set('month', secondNumber - 1 ).set('year', finalYear)
                correctFormField.setValue(finalDate.format('YYYY-MM-DD'))
    
    
    
              // auto-complete the date once two figures are enterted. 24 = 2024, etc. But don't do it when the user is deleting the year.
           /*    if(thirdNumber.length == 2 && !yearShorterThanBefore){
                event.target.value = `${firstNumber}-${secondNumber}-${maybePlus2k}`
                event.target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
              } */
              // correctFormFieldVisible.setValue(`${firstNumber}-${secondNumber}-${plus2k}`)
              // console.log("Date is valid");
            }
          }
        }
      }

      setPopoverVisible(id: string, show: boolean, hideAfter?: number) {
        let popovers: Array<NbPopoverDirective> = this.popovers["_results"];
        let onePopover: NbPopoverDirective = popovers.find(
          (element) => element.context == id
        );
        if (show){ 
          onePopover.show()
        } else {
          if(onePopover){
            onePopover.hide()
          }
        }

        // show ? onePopover.show() : onePopover.hide();
        if (show == true && hideAfter) {
          setTimeout(() => {
            onePopover.hide();
          }, hideAfter);
        }
      }

        /**
   * @param {FormGroup} formGroupRef - A reference to the FormGroup object utilised in the datatype using this function..
   * @param {FormBuilder} formBuilderRef - A reference to the form builder object utilised in the datatype using this function.
   * @param {StateService} stateRef - A reference to the state service utilised in the datatype using this function.
   * @param {entryProp[]} dataFields - Either just the data schema or the data schema with values to prefill the form, e.g. when editing the data  and data is already available.
   * @param {prefillFormWithValues} [prefillFormWithValues=false] - If the passed dataFields have a .value property defined (e.g. when editing existing data), prefill the forms with these values.
   * @returns { void }
   */
    createForm(formGroupRef : FormGroup, formBuilderRef : FormBuilder, stateRef : StateService, dataFields: entryProp[],  prefillFormWithValues = false){
      const setDateIfDefined = (datafield) => {
        if(datafield.value){
          return new Date(datafield.value)
        }
      }
      
      for (const dataField of dataFields) {
        const validatorsToAdd = [];

        // handle required:
        if (dataField.required) {
          validatorsToAdd.push(Validators.required);
        }

        // handle length
        if (dataField.minLength) {
          validatorsToAdd.push(Validators.minLength(dataField.minLength));
        }
 
        // TODO: Discontinue "date" type, only used in some data types which are not updated to use generic templates.
        // add extra controls for date
        // 'visible' is defined by datepicker component
        if (dataField.type === "date") {
          formGroupRef.addControl(
            dataField.name + "-visible",
            formBuilderRef.control("", [Validators.required, DateValidator.validateDateFormat])
          );

        }

    // handle datatype-specific validators:
    switch (dataField.type) {
      case "email":
        validatorsToAdd.push(Validators.email);
        break;
      case "boolean":
         validatorsToAdd.push(BoolValidator.validateBool);
        break;
      case "password":
        validatorsToAdd.push(PasswordValidator.strong);
        break;
      case "matricule":
        // required-ness is handled above; an optional matricule may stay empty.
        validatorsToAdd.push(dataField.required ? MatriculeValidator.validateMatricule : MatriculeValidator.validateMatriculeOptional);
        break;
        case "dateBefore":
          formGroupRef.addControl(
            dataField.name + "-visible",
            formBuilderRef.control(prefillFormWithValues ? setDateIfDefined(dataField) : null, [Validators.required, DateValidator.validateDateBefore])
          );
          validatorsToAdd.push(DateValidator.validateDateFormat);
          validatorsToAdd.push(DateValidator.validateDateBefore);
        break;
        case "dateAfter":
          formGroupRef.addControl(
            dataField.name + "-visible",
            formBuilderRef.control(prefillFormWithValues ? setDateIfDefined(dataField) : null, [Validators.required, DateValidator.validateDateAfter])
          );
          validatorsToAdd.push(DateValidator.validateDateFormat);
          validatorsToAdd.push(DateValidator.validateDateAfter);
        break;
        case "dateAny":
          formGroupRef.addControl(
            dataField.name + "-visible",
            formBuilderRef.control(prefillFormWithValues ? setDateIfDefined(dataField) : null, [Validators.required/* , DateValidator.validateDateFormat */]) // the visible field's date does not need date validation ?
          );

          validatorsToAdd.push(DateValidator.validateDateFormat);
        break;
      default:
        break;
    }
    formGroupRef.addControl(
      dataField.name,
      /* formBuilderRef.control("", validatorsToAdd) */
      formBuilderRef.control(prefillFormWithValues ? dataField.value : "" , validatorsToAdd)
    );
  }
}
/**
 * This function is used to patch form data before creating an entry, e.g. formatting values based on their type, etc.
 * 
 * @param {FormGroup} form - The form group to patch.
 * @param {entryProp[] | indexDataField[]} schema - The schema of the data type.
 * */
    patchFormDataBeforeCreate(form: FormGroup, schema: entryProp[] | indexDataField[]) {
      // this function is meant to be overwritten in the child class
      // 1. if the schema has entries of datatype number, we need to replace all commas with dots for the corrresponding field values in the form group. 

      // 1.1 in the schema, find all fields that are of type number.
      let numberFields = schema.filter((field) => field.type == "number")
      
      // 1.2 for each field, replace all commas with dots in the corresponding form group field.
      numberFields.forEach((field) => {
        let formControl = form.controls[field.name]
        formControl.setValue(formControl.value.replace(/,/g, '.'))
      })


    }

    logForm() {
        console.devlog(this.entryForm)
      }
      
/**
 * 
 * @param address : LocationAddress - Address data to add to the form input.
 */

  addAddressToFormInput(address : LocationAddress) {
    this.entryForm.controls['street'].setValue(address.street);
    this.entryForm.controls['streetNumber'].setValue(address.streetNumber);
    this.entryForm.controls['city'].setValue(address.city);
    this.entryForm.controls['zipCode'].setValue(address.zipCode);
    this.entryForm.controls['country'].setValue(address.country);
    this.entryForm.controls['gpsLat'].setValue(address.gpsLat);
    this.entryForm.controls['gpsLng'].setValue(address.gpsLng);
  }

   /**
   * Helper function to infer a generic error type from a Strapi error message string.
   * @param message The raw error message from the API.
   * @returns A generic error type string (e.g., 'unique', 'minLength').
   */
  private getStrapiErrorType(message: string): string {
    const msg = message.toLowerCase();
    if (msg.includes("must be unique")) return "unique";
    if (msg.includes("must be at least")) return "minLength";
    if (msg.includes("must be less than or equal to")) return "max";
    if (msg.includes("must be greater than or equal to")) return "min";
    if (msg.includes("must be a valid email")) return "invalidEmail";
    if (msg.includes("is required")) return "required";
    if (msg.includes("must match")) return "mustMatch";
    // Add more rules as needed for other Strapi default messages
    return "generic"; // Fallback for unknown messages
  }
  
  /**
   * Handles API errors by parsing the Strapi error object, translating messages,
   * and displaying them in both the form inputs and a toast notification.
   * @param error The error object from the Axios catch block.
   */
  handleApiError(error: any) {
    console.deverror("API Error:", error);

    const errorTitle = this.translate.instant("dict.error");
    const genericToastMessage = this.translate.instant("errors.api.generic");

    // Handle detailed validation errors from Strapi
    if (error.response?.data?.error?.details?.errors) {
      const errors = error.response.data.error.details.errors;
      const translatedErrorMessages: string[] = [];

      errors.forEach((err: any) => {
        if (err.path && err.path.length > 0) {
          const fieldName = err.path[0];
          const control = this.entryForm.get(fieldName);

          const errorType = this.getStrapiErrorType(err.message);
          const fieldInfo = this.dataSchema?.find((f) => f.name === fieldName);
          // Use the human-readable label from the schema, or fall back to the field name
          const fieldLabel = fieldInfo?.label || fieldName;

          // Construct translation keys, one specific and one generic fallback
          const translationKey = `errors.api.${this.dataType}.${fieldName}.${errorType}`;
          const fallbackKey = `errors.api.validation.${errorType}`;

          // Attempt to translate the error message
          let translatedMessage = this.translate.instant(translationKey, {
            field: fieldLabel,
          });

          // If the specific key is not found, instant() returns the key itself. Try the fallback.
          if (translatedMessage === translationKey) {
            translatedMessage = this.translate.instant(fallbackKey, {
              field: fieldLabel,
            });
          }

          // If the fallback is also not found, use the original message from the API as the last resort.
          if (translatedMessage === fallbackKey) {
            translatedMessage = err.message;
          }

          if (control) {
            // Set the translated error on the form control
            control.setErrors({ apiError: translatedMessage });
            control.markAsTouched(); // This will trigger SCSS for invalid fields
          }
          translatedErrorMessages.push(`${fieldLabel}: ${translatedMessage}`);
        }
      });

      // Join the messages for the toast notification
      const toastMessage =
        translatedErrorMessages.length > 0
          ? translatedErrorMessages.join("\n")
          : genericToastMessage;

      this.api.toastrService.danger(toastMessage, errorTitle, {
        duration: 8000,
        preventDuplicates: true,
        // You may need a custom toast component to render HTML, or use a library that supports it.
        // For now, assuming the default toastr can handle simple HTML like <br>.
      });
    } else if (error.response?.data?.error?.message) {
      // Handle other, more generic error messages from the backend
      const serverMessage = error.response.data.error.message;
      this.api.toastrService.danger(serverMessage, errorTitle, {
        duration: 5000,
        preventDuplicates: true,
      });
    } else {
      // Fallback for network errors or other unknown issues
      this.api.toastrService.danger(genericToastMessage, errorTitle, {
        duration: 5000,
        preventDuplicates: true,
      });
    }
  }
}
